import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify'; 
import 'react-toastify/dist/ReactToastify.css'; 

import Auth from './layouts/Auth';
import GetStarted from './layouts/GetStarted';
import User from './layouts/User';
import BigCommerceSearchLogin from './layouts/BigCommerceSearchLogin';
import Search from './layouts/Search';
import Upsell from './layouts/Upsell';
import AIAssistant from './layouts/AIAssistant';
import CmsAssistant from './layouts/CmsAssistant';
import AiVisibility from './layouts/AiVisibility';
import ShopifySearchLogin from './layouts/ShopifySearchLogin';
import AiVisibilityAppLogin from './layouts/AiVisibilityAppLogin';
import ActivityRouteListener from './components/ActivityRouteListener';
import Logout from './Views/Pages/Auth/Logout';

import "./assets/scss/users.scss";
import "./assets/scss/search.scss";
import "./assets/scss/grader-report/grader-report.scss";
import "./assets/scss/badge/aivisibility-report.scss";
import "./assets/scss/badge/aivisibility-writing.scss";
import "./assets/scss/badge/aivisibility-dual-lens.scss";
import "./assets/scss/badge/aivisibility-llms-txt.scss";
import "./assets/scss/badge/aivisibility-schema-optimizer.scss";
import "./assets/scss/badge/aivisibility-monitoring.scss";
import "./assets/scss/shared/ai-provider-icon.scss";

function App() {


  return (
    <BrowserRouter>
      <ActivityRouteListener />
      <Routes>
        <Route path='/search-bigcommerce/' element={<BigCommerceSearchLogin />} />
        <Route path='/search-shopify/' element={<ShopifySearchLogin />} />
        <Route path='/aivisibility-shopify/' element={<AiVisibilityAppLogin platform="shopify" />} />
        <Route path='/aivisibility-bigcommerce/' element={<AiVisibilityAppLogin platform="bigcommerce" />} />
        <Route path="/auth/*" element={<Auth />} />
        <Route path='/getStarted/*' element={<GetStarted />} />
        <Route path="/user/logout" element={<Logout />} />
        <Route path="/user/*" element={<User />} />
        <Route path="/search/*" element={<Search />} />
        <Route path="/upsell/*" element={<Upsell />} />
        <Route path="/aiassistant/*" element={<AIAssistant />} />
        <Route path="/cmsassistant/*" element={<CmsAssistant />} />
        <Route path="/aivisibility/*" element={<AiVisibility />} />
        <Route path="*" element={<Navigate to="/auth/login" replace />} />
      </Routes>

      {/* ToastContainer should be placed here */}
      {/* <ToastContainer
        position="top-right" 
        autoClose={3000} 
        hideProgressBar={false} 
        newestOnTop={false} 
        closeOnClick 
        rtl={false} 
        pauseOnFocusLoss
        draggable
        pauseOnHover
      /> */}
    </BrowserRouter>
  );
}

export default App;
